import { render, staticRenderFns } from "./MediaChannels.vue?vue&type=template&id=011d9f9e&scoped=true"
import script from "./MediaChannels.vue?vue&type=script&lang=js"
export * from "./MediaChannels.vue?vue&type=script&lang=js"
import style0 from "./MediaChannels.vue?vue&type=style&index=0&id=011d9f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011d9f9e",
  null
  
)

export default component.exports